import React, { useState, useEffect } from 'react';
import { contentTypes } from '../../data/categories';

const ContentType = ({ onContentChange, initialContentTypes = [] }) => {
  const [selectedContents, setSelectedContents] = useState(initialContentTypes);

  useEffect(() => {
    if (initialContentTypes.length > 0) {
      setSelectedContents(initialContentTypes);
    }
  }, []); // Only run once on mount

  // Use useEffect to notify the parent after the state has been updated
  
  const handleContentSelect = (content) => {
    setSelectedContents((prevState) => {
      if (prevState.includes(content)) {
        return prevState.filter((item) => item !== content);
      } else if (prevState.length < 2) {
        return [...prevState, content];
      } else {
        return prevState; // prevent adding more than 2
      }
    });
  };
  
  useEffect(() => {
    onContentChange(selectedContents);
  }, [selectedContents, onContentChange]);

  return (
    <div className=" w-full  bg-white rounded-lg ">
      <p className="text-md font-medium text-gray-600 mb-4">
        What type of content do you create?(select 2)
      </p>
      <div className="flex flex-wrap  gap-2">
        {contentTypes.map(
          (content) => (
            <button
              type="button"
              key={content}
              onClick={() => handleContentSelect(content.toLowerCase())}
              className={`px-4 py-2 text-sm font-medium border rounded-md ${
                selectedContents.includes(content.toLowerCase())
                  ? 'bg-custom-blue text-gray-800 border-custom-blue'
                  : 'bg-white text-gray-800 border-gray-300 hover:bg-gray-100'
              }`}
            >
              {content}
            </button>
          )
        )}
      </div>
    </div>
  );
};

export default ContentType;

